import React, { useState, useEffect } from "react";
//Icons svg
import { ReactComponent as MagnifyingGlass } from "../../../../../assets/images/magnifyingGlass.svg";
import { ReactComponent as Chevron } from "../../../../../assets/images/chevron.svg";
//Redux
import { useSelector, useDispatch } from "react-redux";
import { loadGarmentValue } from "../../../../../actions/formDataActions";

const FieldOrderQuantity = ({ garment, pos }) => {
  //Store data
  const { formValues } = useSelector((state) => state.dataForm);

  const garmentOptions = [
    {
      name: garment.dataOne.name,
    },
    {
      name: garment.dataTwo.name,
    },
  ];
  //States
  const [valuePlaceholder, setValuePlaceholder] = useState(
    "Seleccione"
  );
  const [displayError, setDisplayError] = useState(false);
  const [selectOptions, setSelectOptions] = useState({
    originalOptions: false,
    workOptions: false,
  });
  const [activeValue, setActiveValue] = useState("");

  //Redux actions
  const dispatch = useDispatch();
  const storeLoadGarmentValue = (valuePair) =>
    dispatch(loadGarmentValue(valuePair));

  //Functions
  const loadInputValue = (e) => {
    //Loads input value in store
    storeLoadGarmentValue([
        pos,
        "quantity",
        e.target.dataset.optionvalue,
      ]);
    setValuePlaceholder(e.target.dataset.optionname);

    setActiveValue(e.target.dataset.optionname);
  };

  const filterSelectOptions = (e) => {
    //Loads new select options according to search field value
    const searchTerm = e.target.value;
    const newOptions = [];
    if (selectOptions) {
      // eslint-disable-next-line
      selectOptions.originalOptions.map((originalOption) => {
        if (
          originalOption.name.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
          newOptions.push(originalOption);
        }
      });
    }
    setSelectOptions({ ...selectOptions, workOptions: newOptions });
  };

  const isCurrent = (option) => {

    //Load style if item is selected
    if (option === formValues.garments[pos]["quantity"]) {
      return " current";
    } else {
      return " ";
    }
  };

  //useEffect
  useEffect(() => {
    if (formValues.garments[pos]["quantity"] && formValues.garments[pos]["quantity"] !== "") {
      setDisplayError(false);
    } else {
      setDisplayError(true);
    }
    // eslint-disable-next-line
  }, [formValues.garments[pos]["quantity"]]);

  useEffect(() => {
    setSelectOptions({
      originalOptions: garmentOptions,
      workOptions: garmentOptions,
    });
    //Load name in input
    if (!formValues.tipo_prenda_id) {
      setActiveValue("");
    } else {
      // eslint-disable-next-line
      garmentOptions.map((dataType) => {
        if (dataType.name === formValues.garments[pos].quantity) {
          setActiveValue(dataType.name);
        }
      });
    }

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {garmentOptions && selectOptions && selectOptions.workOptions && (
        <div className="input-container select">
          <div className="input-label">Cantidad</div>
          <>
            {/* Display collapsed */}
            <div className="input-select-collapsed">
              <input
                type="text"
                disabled
                placeholder={valuePlaceholder}
                className={displayError ? "errorInput" : ""}
                value={activeValue}
              />
              <Chevron />
            </div>
            {/* Display expanded */}
            <div className="input-select-expanded">
              <div className="input-select-expanded__container">
                {/* fixed search */}
                <div className="input-select-expanded__search">
                  <input type="text" onChange={filterSelectOptions} />
                  <MagnifyingGlass />
                </div>
                <div className="input-select-expanded__option-container">
                  {/* Filter - Select - Options - API */}
                  {selectOptions &&
                    selectOptions.workOptions.map((item, index) => (
                      <div
                        className={
                          "input-select-expanded__option " + isCurrent(item.name)
                        }
                        key={index}
                        data-name="quantity"
                        data-optionvalue={item.name}
                        data-optionname={item.name}
                        onClick={loadInputValue}
                      >
                        {item.name}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </>
        </div>
      )}
    </>
  );
};

export default FieldOrderQuantity;
